import { render } from "./index.vue?vue&type=template&id=6a5010be&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6a5010be&lang=scss&scoped=true"

import exportComponent from "D:\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5010be"]])

export default __exports__